<template>
  <div class="crm-client-container">
    <!-- 面包屑导航 -->
    <Breadcrumb :levelList="levelList" />
    <div class="clearfix">
      <el-button type="primary" size="small" class="crm-add-tag" @click="handleAddField()">添加新字段</el-button>
    </div>
    <el-scrollbar class="crm-scrollbar">
    <!-- 表格组件： -->
    <div class="crm-table-container">
      <el-table
        v-loading="Loading"
        :data="tableList"
        style="width: 100%;"
        :header-cell-style="rowClass"
        :cell-style="cellStyle"
      >
        <el-table-column prop="name" label="字段名" align="center" />
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.colStatusShow"
              active-text="开"
              inactive-text="关"
              :active-value="1"
              :inactive-value="0"
              active-color="#337eff"
              inactive-color="#EAECF0"
              :disabled="scope.row.cannotEdit"
              @change="handleUpdateCustomerColStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="showSysDesc" label="应用场景" align="center" />
        <el-table-column prop="modifyUserName" label="修改人" align="center" />
        <el-table-column prop="modifyDate" label="最近修改时间" align="center" />
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
              <i class="iconfont icontable-bianji" @click="handleAddField(scope.row)" v-if="!scope.row.cannotEdit"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <i
                class="iconfont icontable-delete"
                @click="handleDeleteField(scope.row.id)"
                v-if="scope.row.type !=='default_type'"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页数据 -->
    <el-row style="float:right;margin-right: 10px">
      <el-pagination
        class="pageStyle"
        background
        layout="total, prev, pager, next, jumper"
        :page-size.sync="listQuery.size"
        :current-page.sync="listQuery.current"
        :total="total"
        @current-change="handlePagination"
      ></el-pagination>
    </el-row>
    </el-scrollbar>
    <!-- 添加标签组件 -->
    <addFieldComponent
      ref="addField"
      :action="action"
      @emitPagination="emitPagination"
      :customizeList="customizeList"
    />
  </div>
</template>
<script>
import Breadcrumb from '@/views/components/crm/Breadcrumb'
import addFieldComponent from './components/addField'
import {
  getCustomerColByPage,
  updateCustomerColStatus,
  deleteCustomerCol,
  getCustomerField
} from '@/api/crm/clientInfo'

export default {
  components: { Breadcrumb, addFieldComponent },
  data() {
    return {
      total: 10,
      listQuery: {
        current: 1,
        size: 10
      },
      Loading: false,
      tableList: [],
      levelList: [{ path: '/client_info', title: '客户信息' }],
      // 应用场景枚举值
      showSysMap: {
        AICC_CRM: '客户管理',
        AICC_WORKBENCH: '在线坐席',
        AICC_ORDER: '工单系统'
      },
      action: 'add',
      mould: 3003,
      customizeList: [],
      fixedFieldList: ['name', 'mobile', 'email', 'default_label', 'level', 'visitor_remark']
    }
  },
  created() {
    this.handlePagination()
    this.getCustomerFieldList()
  },
  methods: {
    rowClass() {
      return 'background:#F5F5F5;border-right: 1px solid #fff;text-align:center;'
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label === '操作') {
        return 'text-align:center;padding-left:10px;'
      }
    },
    getCustomerFieldList() {
      // 获取自定义字段
      const option = {
        // type: 'textfield',
        categoryCode: 'customer'
      }
      getCustomerField(option).then(res => {
        this.customizeList = res.data
      })
    },
    emitPagination() {
      this.handlePagination()
    },
    handlePagination() {
      const _this = this
      getCustomerColByPage(this.listQuery).then(res => {
        _this.total = res.data.total
        _this.tableList = res.data.records
        _this.tableList.map(item => {
          // 当 colStatus == 2 时，该字段状态不允许修改
          item.cannotEdit = item.colStatus === 2
          // 兼容状态列展示 (colStatus 可能有多种值，此处只区分关闭为0，其他为打开)
          item.colStatusShow = item.colStatus === 0 ? 0 : 1
          item.showSysArr = []
          if (item.showSys) {
            const showSysArr = item.showSys.split(',')
            item.showSysArr = showSysArr
            item.showSysDesc = showSysArr
              .map(element => {
                return _this.showSysMap[element]
              })
              .join('，')
          }
        })
      })
    },
    handleAddField(row) {
      if (row) {
        this.action = ''
        // 系统默认字段除了固定的6个字段外，其他不在坐席工作台展示，固定的6个字段的应用场景不可编辑
        row.showWorkbench = true
        if (row.type === 'default_type') {
          if (!(this.fixedFieldList.includes(row.tag))) {
            row.showWorkbench = false
          } else {
            row.disabled = true
          }
        }
        this.$refs.addField.fieldForm = { ...row }
      } else {
        this.action = 'add'
        this.$refs.addField.fieldForm.showWorkbench = true
      }
      this.$refs.addField.isShowRoleDialog = true
    },
    handleUpdateCustomerColStatus(row) {
      const data = {
        id: row.id,
        colStatus: row.colStatusShow,
        mould: this.mould
      }
      updateCustomerColStatus(data).then(res => {
        this.handlePagination()
      })
    },
    handleDeleteField(id) {
      this.$confirm('删除该字段，将会清除跟字段有关的数据, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = { id: id, mould: this.mould }
        deleteCustomerCol(data).then(res => {
          if (res.code === '2000') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.handlePagination()
          } else if (res.code === '1008') {
            this.handlePagination()
          }
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.crm-client-container {
  height: 100%;
  position: relative;
}
.crm-scrollbar {
  height: calc(100% - 50px - 62px);
}
.crm-add-tag.el-button {
  float: right;
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
